<template>
  <div
    class="card"
  >
    <div
      :id="`card${service.id}`"
      class="contents"
    >
      <div
        v-if="showImage"
        :class = "{
                  'left' : thumbNail,
                  'hideImageClass': !thumbNail
                  }"
      >
        <img
          v-if="!isVideo(thumbNail)"
          :src="thumbNail"
          class="image"
        >
        <video
          v-if="isVideo(thumbNail)"
          :src="thumbNail"
          :alt="thumbNail"
          playsinline
          class="image"
        ></video>
        <!-- <p class="count">{{service.imageUrl.length}}</p> -->
      </div>
      <div class="right">
        <div class="top">
          <p class="name">
            <span
              v-if="service.isHighlighted"
              class="badge"
            >
              {{ $t("updated") }}
            </span>
            {{ service.name }}
          </p>
          <button class="view-details"
           v-if="service.category !== '3' && categoryServicesShownOnRoute(service.category).length > 0"
          :tabindex="canOpenPopup ? '0' : null"
          :role="canOpenPopup ? 'button' : null"
          :aria-label="canOpenPopup ? service.name : null"
          @click="openService(service)"
          @keydown.enter="openService(service)"
          >
          <span v-if="!service.itemLevelMediaUrls">{{$t("viewDetails")}}</span>
          <span v-if="service.itemLevelMediaUrls">{{ $t("viewDetails") + ' ' + '(' +  service.itemLevelMediaUrls.length + ' ' + $t("mediaAttached") + ')'}}</span>

          <img
          class="chevron"
          src="@/assets/images/chevron-right-customs.svg"
          aria-hidden="true"
          >
          </button>
          <div
            v-if="service.category > '5'"
            class="description"
          >
            <img
              :src="service.iconUrl"
              :aria-label="alt(service)"
              class="dot"
            >
            <p class="text">
              {{ recommendationLabel(service) }}
            </p>
          </div>
        </div>
        <div
          v-if="getServiceDisplayPrice(service) !== false"
          class="bottom"
        >
          <div class="price">
            {{ getServiceDisplayPrice(service) }}
          </div>
          <div class = "approveService">
         <input  
          :class="(service.isApproved || this.$store.state.isReadOnly) ? 'already-approved'  : 'approve'"
          v-model="service.isApproveSelected" 
          :id="`approve${service.id}`" 
          ref="input" 
          type="checkbox"
          value = "approve"
          name="approve" 
          :disabled="this.$store.state.isReadOnly || service.isApproved" 
          @change="approve($event, service)" 
          @click.stop
          >
          <label 
          tabindex="0"
          :for="`approve${service.id}`" 
          class="checkbox-approve" 
          @click.stop
          @keydown.enter="$refs.input.click()">
            {{ $t("approve") }}
            <div class="box">
              <img src="@/assets/images/check.svg" alt="check2" class="check">
            </div>
          </label>
          <input 
          v-model="service.isDeferSelected"  
          :id="`defer${service.id}`"
          ref="input" 
          type="checkbox"
          value = "defer"
          class="defer"
          name="defer"
          :disabled="this.$store.state.isReadOnly || service.isApproved" 
          @click.stop
          @change="reject($event, service)" 
         >
          <label 
          tabindex="0" 
          :for="`defer${service.id}`" 
          class="checkbox-defer"
          @click.stop
          @keydown.enter="$refs.input.click()">
            {{ $t("decline") }}
            <div class="box">
              <img src="@/assets/images/check.svg" alt="check1" class="check">
            </div>
          </label>
          </div> 
        </div>
      </div>
    </div>
    <div class="divider" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import { formatCurrency, getServiceDisplayPrice } from '@/mixins.js'

export default {
  name: 'ServiceCard',
  mixins: [
    formatCurrency,
    getServiceDisplayPrice
  ],
  props: {
    category: {
      type: Object,
      required: true,
      default: () => {}
    },
    service: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  computed: {
    ...mapGetters([
      'categoryById',
      'isPass',
      'categoryServicesShownOnRoute',
      'categoriesShown'
    ]),
    ...mapState([
      'inspectionLevelMediaUrl',
      'inspectionLevelMediaUrls',
      'itemLevelMediaUrls'

    ]),
    services() {
      let services = []
      for (const category of this.categoriesShown) {
        if (!this.isPass(category.id)) {
          services = services.concat(this.categoryServicesShownOnRoute(category.id))
        }
      }
      return services.filter(service => service.category !== '3')
    },
    showImage() {
      const category = this.$store.getters.categoryById(this.service.category)
      if (category && typeof category.serviceCategoryType === 'string') {
        return category.serviceCategoryType.toLowerCase() !== 'pass' && category.id < '5'
      }
      return true
    },
    canOpenPopup () {
      return this.service.category !== '3'
    },
    thumbNail () {
      if(this.service.imageUrl)
      {
        let imageUrl = this.service.imageUrl.split(';');
         return  imageUrl[0];
      }
      else
      {
        return null;
      }
    }
  },
  methods: {
    ...mapActions([
      'viewService'
    ]),
    ...mapMutations([
      'setService',
      'unselectService',
      'openReason',
      'logEvent',
      'closeService',
      'unselectDefer',
    ]),
    openService (service) {
      if (this.canOpenPopup) {
        this.viewService(service)
      }
    },
    isVideo(slide) {      
      if (slide !== null) {
        let splitedArray = slide.split('.')
        let lastValueOfArray = splitedArray[splitedArray.length - 1].split('?')[0]
        return (lastValueOfArray === 'mp4' || lastValueOfArray === 'flv' || lastValueOfArray === 'm4a' || lastValueOfArray === '3gp' || lastValueOfArray === 'mkv' || lastValueOfArray === 'mov' || lastValueOfArray === 'mkv')
      }
      return false
    },
    alt (service) {
      const statuses = {
        '6': 'red status light',
        '7': 'yellow status light',
        '8': 'green status light',
        '9': 'grey status light'
      }
      return statuses[service.category] || 'status indicator'
    },
    recommendationLabel (service) {
      return service.category < '8' ? this.$t('problem_identified') : this.$t('no_issue_found')
    },
    approve(event, service) {
      event.stopPropagation()
      if(service.isApproved)
      {        
        return;
      }
      if(event.target.checked) {
        service.isDeferSelected = false
        service.isApproveSelected = true
        service.isSelected = true
        } else {
        service.isApproveSelected = false
        service.isSelected = false
        }
    },
    reject(event, service) {
       if(service.isApproved)
      {       
        return;
      }
      event.stopPropagation()
          if (event.target.checked) {
            service.isDeferSelected = true;
            service.isApproveSelected = false;
            if(this.$store.state.isDisableDeclineReasons != true) {
              this.openService(service)
              this.openReason()
            } else {
              service.declinedReasonId = 0
            }
           service.isSelected = false;
          } else {
            service.isDeferSelected = false;
            service.isSelected = false;
          }
    }
  }
}
</script>

<style scoped lang="scss">


.card {
  display: flex;
  flex-direction: column;
  padding: 0 1rem;
  .contents {
    display: flex;
    border: none;
    background-color: var(--white);
    padding: 0;
    .hideImageClass {
      display: none;
    }
    .left {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 10rem;
      height: 10rem;
      .image {
        width: 10rem;
        height: 10rem;
        object-fit: cover;
        border-radius: 3px;
      }
      .count {
        position: absolute;
        margin: 0;
        padding: 0.2rem 0.5rem;
        background-color: var(--grey-dark-background);
        border-radius: 500px;
        font-family: 'Futura Heavy';
        color: var(--white);
      }
    }
    .right {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin-left: 1rem;
      .top {
        display: flex;
        flex-direction: column;
        .name, .description {
          margin: 0;
        }
      .view-details {
        cursor: pointer;
        margin-top: 0.25rem;
        padding: 0px;
        width: fit-content;
        font-weight: 600;
        font-family: 'Futura Book';
        border: none;
        background: none;
        display: flex;
        color: #348185;
        opacity: 1;
        .chevron {
          height: 1.5rem;
          margin-left: 0.25rem;
        }
      }  
        .name {
          margin-bottom: 0.5rem;
          .badge {
            float: right;
            margin: 0 0 1rem 2rem;
            padding: 0.5rem 1rem;
            background-color: var(--green-pastel);
            border-radius: 500px;
            font-family: 'Futura Heavy';
            text-transform: uppercase;
            color: var(--white);
          }
        }
        .description {
          display: flex;
          align-items: center;
          .dot {
            max-width: 1rem;
            max-height: 1rem;
            object-fit: contain;
          }
          .text {
            margin: 0 0 0 1rem;
          }
        }
      }
      .bottom {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        margin-top: 1rem;
        .price {
          margin: 0 0.5rem 0 0;
          padding: 0.5rem 1rem;
          border-radius: 500px;
          color: var(--blue);
          font-weight: 700;
          letter-spacing: 0.0625rem;
          text-align: center;
          line-height: 1;
          font-family: 'Futura Heavy';
          background-color: var(--grey-light-background);
          white-space: nowrap;
        }
        .approveService{
          display: flex;
          min-width: 200px;
          justify-content: space-around;
        }
        input {
          display: none;
        }
        .checkbox-defer {
          float: right;
          display: flex;
          align-items: center;
          transition: all .2s ease-in;
          text-transform: uppercase;
          color: var(--grey-text);

          .box {
            display: inline-flex;
            justify-content: center;
            align-items: center;
            width: 2.5rem;
            height: 2.5rem;
            margin-left: 1rem;
            border-radius: 3px;
            background-color: var(--grey-medium-background);

            .check {
              max-height: 100%;
              max-width: 100%;
              padding: 0.3rem;
              opacity: 0;
            }
          }
        }
        .checkbox-approve {
          float: right;
          display: flex;
          align-items: center;
          transition: all .2s ease-in;
          text-transform: uppercase;
          color: var(--grey-text);
          .box {
            display: inline-flex;
            justify-content: center;
            align-items: center;
            width: 2.5rem;
            height: 2.5rem;
            margin-left: 1rem;
            border-radius: 3px;
            background-color: var(--grey-medium-background);
            .check {
              max-height: 100%;
              max-width: 100%;
              padding: 0.3rem;
              opacity: 0;
            }
          }
        }

        input.already-approved:checked~.checkbox-approve {
          color: var(--green);
          .box {
            background-color: var(--grey-input-border);
            .check {
              opacity: 1;
            }
          }
        }        
        input.approve:checked~.checkbox-approve {
          color: var(--green);
          .box {
            background-color: var(--green);

            .check {
              opacity: 1;
            }
          }
        }        
        input.defer:checked~.checkbox-defer {
          color: var(--red);
          .box {
            background-color: var(--red);

            .check {
              opacity: 1;
            }
          }
        }
        input.defer:checked~.checkbox-defer {
          color: var(--red);
          .box {
            background-color: var(--red);
            .check {
              opacity: 1;
            }
          }
        }
      }
      @media (max-width: 420px) {
          .bottom {
            display: flex;
            flex-flow: column;
            align-items: flex-start!important;
            margin-top: 0px;
            .approveService {
            
             margin-top: 4px;
             align-items: flex-end;
             min-width: auto;
                  .checkbox-approve {
                    font-size: 3.5vw;
      
                    .box {
                      height: 5vw;
                      width: 5vw;
                      margin-left: 0.5rem;
                    }
                  }     
             .checkbox-defer {
                  font-size: 3.5vw;
                  margin: 4px 0px 0px 10px;
      
                    .box {
                      height: 5vw;
                      width: 5vw;
                      margin-left:0.5rem;
                    }
             }
                  .price{
                    margin-bottom: 2px;
                  }
                }
              }
            }
    }
     @media (max-width: 420px) { 
      .right{
        margin-left: 0.5rem;
      }
    }
  }
  .divider {
    width: 100%;
    height: 2px;
    margin: 1rem 0;
    background-color: var(--grey-light-background)
  }
}
.card:first-child {
  padding-top: 1rem;
}
.card:last-child {
  padding-bottom: 1rem;
  .divider {
    display: none;
  }
}
</style>
